import LeadService from '_services/rest/modules/lead';

export default {
  state: {
    lead: null,
    leadList: null,
  },
  mutations: {
    setLeadList(state, response) {
      state.leadList = response;
    },
    setLead(state, response) {
      state.lead = response;
    },
  },
  actions: {
    getLeadList({ commit }, params) {
      return LeadService.getList(params)
        .then(response => {
          commit('setLeadList', response);
        });
    },
    getLead({ commit }, params) {
      return LeadService.getLeadById(params)
        .then(lead => {
          commit('setLead', lead);
          return lead;
        })
        .catch(error => {
          throw error.message;
        });
    },
  },
};
